export const ONE_MAP = {
  attribution:
    '<img src="https://www.onemap.gov.sg/docs/maps/images/oneMap64-01.png" style="height:20px;width:20px;"/> OneMap | &copy <a href="http://SLA.gov.sg">SLA</a>  &nbsp&nbsp&nbsp',
  url: {
    default: 'https://maps-{s}.onemap.sg/v3/Default/{z}/{x}/{y}.png',
    night: 'https://maps-{s}.onemap.sg/v3/Night/{z}/{x}/{y}.png',
    grey: 'https://maps-{s}.onemap.sg/v3/Grey/{z}/{x}/{y}.png'
  },
  markerUrl: {
    source:
      'https://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=%E2%80%A2|abcdef&chf=a,s,ee00FFFF',
    destination:
      'https://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=%E2%80%A2|2ecc71&chf=a,s,ee00FFFF'
  }
}
